import React from 'react'
import { Box, Tooltip, Typography } from '@mui/material'
import { NodeType } from 'shared/types/ingestion'
import { NodePathItem } from './types'

const FILTERED_NODE_TYPES: NodeType[] = [NodeType.NodeList, NodeType.Inline]

function filteredPathItems(path: NodePathItem[]): NodePathItem[] {
  return path
    .slice(0, -1)
    .filter((item) => !FILTERED_NODE_TYPES.includes(item.type))
}

export function NodePathCell({ path }: { path: NodePathItem[] }) {
  const filteredPath = filteredPathItems(path)

  if (filteredPath.length === 0) {
    return null
  }

  const tooltipText = filteredPath.map((item) => item.title).join(' > ')

  return (
    <Tooltip title={tooltipText} enterDelay={500} placement="top">
      <Box display="flex" flexDirection="column" gap="2px">
        {filteredPath.map((item, idx) => (
          <Typography
            key={idx}
            variant="body2"
            style={{
              fontSize: '0.75rem',
              lineHeight: 1.2,
            }}
          >
            {item.title}
          </Typography>
        ))}
      </Box>
    </Tooltip>
  )
}

export function nodePathString(path: NodePathItem[]) {
  return filteredPathItems(path)
    .map((item) => item.title)
    .join(' > ')
}
